import React, { Component,Suspense } from 'react';
import { palette } from '@material-ui/system';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  TextField,
  Typography,
  LinearProgress,
  Avatar} from '@material-ui/core';
import Configuration from '../../service/configuration';
import Resources from '../../service/resources';
import DataServices from '../../service/data-services';
import cookie from 'react-cookies';
import { blue, orange } from '@material-ui/core/colors';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { Footer } from '../../layouts/Main/components';
import { useTranslation, withTranslation } from 'react-i18next'


class AccessRequest extends Component{
    
    constructor(props) {
        super(props);
      
      this.state = {
        errors:{
            error:false, 
            errorMessage:''
        },
        message: false,
        loading: false
      };

      this.config = new Configuration( );
      this.resources = new Resources();
      this.dataService = new DataServices( );
      this.t = this.props.lang;
      this.i18n = this.props.i18n;
    }
    
    // updating state data when text box data changed
    handleValueChange(event) {
        this.setState(Object.assign(this.state.login,{ [event.target.name]:event.target.value}));
    }
    
    render(){
        return(
                <div style={{paddingTop: "4%"}}>

                <div style={{height:"100%", paddingTop:"3%"}}>
                Requesting access
                </div>

                <Snackbar open={this.state.errors.error} autoHideDuration={5000}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                     onClose={ ( event ) => { this.setState(Object.assign(this.state.errors,{ ['error']: false }));}}>
                    <MuiAlert severity="error" elevation={6} variant="filled"
                    onClose={ ( event ) => { this.setState(Object.assign(this.state.errors,{ ['error']: false }));}} >
                      {this.state.errors.errorMessage}
                    </MuiAlert>
                </Snackbar>

                </div>
        );
    }
        
    // this method start works after loading the webpage
    componentDidMount() {
        const module_param = this.props.match.params.module;
        const token_param = this.props.match.params.token;

        this.i18n.changeLanguage(this.dataService.getLanguage());
        let d = new Date();
        d.setTime( d.getTime() + ( 1000*60*5 ) );
        cookie.remove( this.config.COOKIE_NAME_TOKEN, { path: '/' });
        cookie.save(this.config.COOKIE_NAME_TOKEN, token_param, { path: '/', d, maxAge:1000*60*5 });
        //cookie.save(this.config.COOKIE_NAME_LOGIN_USER_NAME, this.state.login.username, { path: '/', d, maxAge:items.data.expires_in });
        window.sessionStorage.setItem(this.config.COOKIE_NAME_TOKEN, token_param);
        this.loadDuration( token_param, module_param );
    }


    loadDuration( token_param, module_param ){
        this.dataService.retrieve( this.config.SERVICE_NAME_USER,
        this.config.SERVICE_ACTION_USER_ROLE_CHECK ).then(items => {
            if( items ) {
                var expireAfter = items.data.expireAfter;
                var userName = items.data.userName;
                let d = new Date();
                d.setTime( d.getTime() + ( expireAfter * 1000 ) );
                cookie.remove( this.config.COOKIE_NAME_TOKEN, { path: '/' });
                cookie.save(this.config.COOKIE_NAME_TOKEN, token_param, { path: '/', d, maxAge:expireAfter });
                cookie.save(this.config.COOKIE_NAME_LOGIN_USER_NAME, userName, { path: '/', d, maxAge:expireAfter });
                window.sessionStorage.setItem(this.config.COOKIE_NAME_TOKEN, token_param);

                this.loadBrief( module_param );
            }else{
                this.dataService.removeUserData();
                this.state.errors.error = true;
                this.state.errors.errorMessage = this.config.MESSAGE_AUTH_FAILED;
                this.setState({loading:false});
            }
        });
    }

    loadBrief(module_param){
        this.dataService.retrieve( this.config.SERVICE_NAME_USER, this.config.SERVICE_ACTION_USER_BRIEF).then(items => {
            if( items ) {
                    this.dataService.storeCurrentUserData( items.success? items.data : null );
                    this.loadAuthorities( module_param );
            }else{
                this.dataService.removeUserData();
                this.state.errors.error = true;
                this.state.errors.errorMessage = this.config.MESSAGE_AUTH_FAILED;
                this.setState({loading:false});
            }
        });
    }

    loadAuthorities( module_param ){
        this.dataService.retrieve( this.config.SERVICE_NAME_USER,
        this.config.SERVICE_ACTION_USER_ROLE_CHECK ).then(items => {
            if( items ) {
                var auth = items.data.authorities;
                window.sessionStorage.setItem(this.config.COOKIE_NAME_AUTH, auth);
                this.userData = this.dataService.getCurrentUserData();
//                window.location.href= '/pos_report_order';
                if( this.userData.roleName ==='Employee' ){
                    window.location.href= '/deman_detail/' + this.userData.guid+'/'+this.userData.name+'/'+this.userData.personId+'/0';
                }else if( this.userData.roleName ==='OS' ){
                    this.loadPOSPrivilege(module_param);
                }else{
                    window.location.href= '/organization_admin_dashboard';
                }
            }else{
                this.dataService.removeUserData();
                this.state.errors.error = true;
                this.state.errors.errorMessage = this.config.MESSAGE_AUTH_FAILED;
                this.setState({loading:false});
            }
        });
    }

    loadPOSPrivilege(module_param){
        this.dataService.retrieve( this.config.SERVICE_NAME_SETTINGS,
        this.config.SERVICE_ACTION_SETTINGS_LOCAL_GET_BY_NAME+'allow_pos?merchantGuid='+this.userData.guid ).then(items => {
            if( items && items.success ) {
                    this.dataService.setCurrentUserPOSPrivilege( items.success? items.data : null );
                    this.userData = this.dataService.getCurrentUserData();
                    if( items.data.value==='true' ){
                        if( module_param === 'pos'){
                            window.location.href= '/pos_report_order';
                        }else{
                            window.location.href= '/' + module_param;
                        }
                    }else
                        window.location.href= '/merchant_detail/' + this.userData.guid+'/'+this.userData.name+'/'+this.userData.personId+'/0';
            }
        });
    }
}
//export default withRouter(Login);
//export default Login;
export default (props) => {
    const { t, i18n } = useTranslation();
    return (<AccessRequest lang={t} i18n={i18n} props{... props} />)
}